import { graphql } from 'gatsby'
import React from 'react'
import MinimalHero, {
  MinimalHeroContent,
} from 'src/components/organisms/heroes/minimalHero'
import { PrismicPageDataBodyMinimalHero } from 'src/typings/generated/graphql'

type Props = {
  slice: PrismicPageDataBodyMinimalHero
}

const MinimalHeroSlice = ({ slice }: Props) => {
  const content: MinimalHeroContent = {
    anchor: slice.primary.anchor ?? undefined,
    title: slice.primary.title ?? undefined,
    titleSize: slice.primary.title_size ?? undefined,
    image: slice.primary.image?.gatsbyImageData ?? undefined,
    imageAlt: slice.primary.image?.alt ?? undefined,
    showOverlay: slice.primary.show_overlay ?? true,

    // Fallback to using the same image for mobile until a mobile image field is available in Prismic
    mobileImage: slice.primary.image?.gatsbyImageData ?? undefined,
    mobileImageAlt: slice.primary.image?.alt ?? undefined,
  }

  return <MinimalHero content={content} />
}

export default MinimalHeroSlice

export const MinimalHeroFragment = graphql`
  fragment PageDataBodyMinimalHero on PrismicPageDataBodyMinimalHero {
    primary {
      anchor
      title
      title_size
      show_overlay
      image {
        gatsbyImageData
        alt
        thumbnails {
          mobile {
            gatsbyImageData
            alt
          }
        }
      }
    }
  }
`
